import React, { useEffect, useState } from 'react';
import { Box, Paper, Typography, Button, List, ListItem, ListItemText } from '@mui/material';
import { useParams } from 'react-router-dom';
import api from '../services/api';

const SignatureDetails: React.FC = () => {
    const { id } = useParams();
    const [item, setItem] = useState<any>(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        (async () => {
            if (!id) return;
            setLoading(true);
            try {
                const res = await api.get(`/api/signatures/${id}`);
                setItem(res.data);
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        })();
    }, [id]);

    const handleDownload = async () => {
        try {
            const res = await api.get(`/api/signatures/${id}/download`, { responseType: 'blob' });
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const a = document.createElement('a');
            a.href = url;
            a.download = `${id}.pdf`;
            document.body.appendChild(a);
            a.click();
            a.remove();
        } catch (err) {
            console.error('download error', err);
        }
    };

    const handleResend = async () => {
        try {
            await api.post(`/api/signatures/${id}/resend`);
            alert('Reenvio solicitado');
        } catch (err) {
            console.error(err);
            alert('Erro ao solicitar reenvio');
        }
    };

    if (loading) return <Typography sx={{ p: 2 }}>Carregando...</Typography>;
    if (!item) return <Typography sx={{ p: 2 }}>Registro não encontrado</Typography>;

    return (
        <Box sx={{ p: 2 }}>
            <Paper sx={{ p: 2 }}>
                <Typography variant="h6">Detalhes da Assinatura</Typography>
                <Typography variant="body2">ID: {item._id}</Typography>
                <Typography variant="body2">Tenant: {item.tenantId}</Typography>
                <Typography variant="body2">Status: {item.status}</Typography>

                <Box sx={{ mt: 2 }}>
                    <Typography variant="subtitle1">Signatários</Typography>
                    <List>
                        {(item.signers || []).map((s: any, i: number) => (
                            <ListItem key={i}><ListItemText primary={`${s.name} <${s.email}>`} secondary={s.status} /></ListItem>
                        ))}
                    </List>
                </Box>

                <Box sx={{ mt: 2, display: 'flex', gap: 2 }}>
                    <Button variant="contained" onClick={handleDownload}>Baixar</Button>
                    <Button variant="outlined" onClick={handleResend}>Reenviar</Button>
                </Box>

                <Box sx={{ mt: 2 }}>
                    <Typography variant="subtitle1">Logs</Typography>
                    <List>
                        {(item.logs || []).map((l: any, i: number) => (
                            <ListItem key={i}><ListItemText primary={l.event} secondary={JSON.stringify(l.raw)} /></ListItem>
                        ))}
                    </List>
                </Box>
            </Paper>
        </Box>
    );
};

export default SignatureDetails;
